import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import {
  addRegion,
  deleteRegion,
  getAllRegions,
  getRegions,
  updateRegion,
} from '../services/regionService'
import type { RegionQueryParams } from '../services/regionService'

// 查询地区列表（分页）
export function useRegions(params?: RegionQueryParams) {
  return useQuery({
    queryKey: ['regions', params],
    queryFn: () => getRegions(params),
    select: (data) => data.data,
  })
}

// 查询所有地区（下拉选择使用）
export function useAllRegions() {
  return useQuery({
    queryKey: ['regions', 'all'],
    queryFn: getAllRegions,
    select: (data) => data.data,
  })
}

// 添加地区
export function useAddRegion() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addRegion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['regions'] })
      message.success('添加地区成功')
    },
    onError: (error: Error) => {
      message.error(`添加地区失败: ${error.message}`)
    },
  })
}

// 更新地区
export function useUpdateRegion() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateRegion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['regions'] })
      message.success('更新地区成功')
    },
    onError: (error: Error) => {
      message.error(`更新地区失败: ${error.message}`)
    },
  })
}

// 删除地区
export function useDeleteRegion() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteRegion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['regions'] })
      message.success('删除地区成功')
    },
    onError: (error: Error) => {
      message.error(`删除地区失败: ${error.message}`)
    },
  })
}
